import { useReducer } from 'react';
import { Details, File, FormMarkup } from '@components/basicComponents';
import { DSCCFormFields, getDSCCFormData, getDSCCModalData } from '.';
import { handleFormSubmit } from '@utils/forms';
import type { FormExtendedEvent } from 'grommet/components/Form';
import type { FormFieldsDetailsProps, FormProps } from '@customTypes/types';
import type { SingleFormState } from '@customTypes/stateTypes';

const formTitle: string = 'HPE GreenLake Data Services';

export const DSCCForm = (props: FormProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: SingleFormState, newState: Partial<SingleFormState>) => ({
      ...prev,
      ...newState,
    }),
    {
      showDetails: false,
      numFiles: 0,
    }
  );

  const onDetailsChange = (value: FormFieldsDetailsProps) => {
    updateState(value);
  };

  const onFileChange = (value: number): void => {
    updateState({ numFiles: value });
  };

  const getOnSuccess = (helpWith, helpWithSecondary) => {
    const modalData = getDSCCModalData(helpWith, helpWithSecondary);
    return () => props.onSuccess(true, modalData);
  };

  const onSubmit = ({ target, value }: FormExtendedEvent) => {
    const data = getDSCCFormData(target, value.helpWith, value.helpWithSecondary, value.companyName, value.severity, value.issueTitle);
    const onSuccess = getOnSuccess(value.helpWith, value.helpWithSecondary);

    handleFormSubmit(data, onSuccess, props.onError, props.onLoading);
  };

  let clearFormFieldsState;

  const assignClearFormFieldsState = (formFieldsClearStateFunc: Function): void => {
    clearFormFieldsState = formFieldsClearStateFunc;
  };

  const onReset = (): void => {
    clearFormFieldsState && clearFormFieldsState();
    updateState({ numFiles: 0 });
  };

  return (
    <FormMarkup
      onSubmit={onSubmit}
      onReset={onReset}
      formTitle={formTitle}
      doubleFieldPhone={true}
      formFields={
        <>
          <DSCCFormFields
            onDetailsChange={onDetailsChange}
            onReset={assignClearFormFieldsState}
          />

          {state.showDetails &&
            <>
              <Details />

              <File numFiles={state.numFiles} onFileChange={onFileChange} />
            </>
          }
        </>
      }
    />
  );
};
